import { useAuth } from 'util/auth'
import { useCustomer } from './customers'
import { useTeamsWhereMember } from './teams'
import { useListProjects } from './projects'

export const useUserPlan = () => {
  const auth = useAuth()

  const customer = useCustomer({ userId: auth.user ? auth.user.id : '' })

  const capitalizeFirstLetter = (string: string) => {
    return string.charAt(0).toUpperCase() + string.slice(1)
  }

  const { data: teamsWhereMember } = useTeamsWhereMember({
    userId: auth.user ? auth.user.id : '',
  })

  const plan =
    auth.user && auth.user.planId && auth.user.planIsActive
      ? capitalizeFirstLetter(auth.user.planId)
      : teamsWhereMember?.length || 0 > 0
      ? 'Team'
      : 'Free'

  const planId = auth.user ? auth.user.planId : ''

  const isTrialing = customer.data?.stripeSubscriptionStatus === 'trialing'

  const isInactive = plan === 'Free'

  const getMaxProjects = (
    plan: string
  ): {
    maxProjects: number
  } => {
    if (
      plan.toLowerCase().includes('base') ||
      plan.toLowerCase().includes('creator')
    )
      return {
        maxProjects: 1,
      }
    if (
      plan.toLowerCase().includes('plus') ||
      plan.toLowerCase().includes('network') ||
      plan.toLowerCase().includes('entrepreneur')
    )
      return {
        maxProjects: 5,
      }
    if (
      plan.toLowerCase().includes('max') ||
      plan.toLowerCase().includes('agency')
    )
      return {
        maxProjects: 10000,
      }
    return {
      maxProjects: 1,
    }
  }

  const { data: projects } = useListProjects()

  const maxProjects = getMaxProjects(plan).maxProjects
  const remainingProjects = maxProjects - (projects?.totalCount ?? 0)

  return {
    plan,
    planId,
    isTrialing,
    isInactive,
    maxProjects,
    remainingProjects,
  }
}
